module.exports = __webpack_public_path__ + "media/images/icons/bi-hand-thumbs-up-fill-d8da64c4de1ba8dc23103b7cbf4507b5.png";